export const themeConfig = {
  palette: {
    type: "light",
    primary: {
      main: "#005fcc",
    },
    secondary: {
      main: "#171718",
    },
    warning: {
      main: "#e59900",
    },
  },
  typography: {
    fontSize: 12,
    fontFamily: "Inter-Regular",
    fontWeightLight: 400,
    textTransform: "none",
  },
  props: {
    MuiList: {
      dense: true,
    },
    MuiMenuItem: {
      dense: true,
    },
    MuiTable: {
      size: "small",
    },
    MuiTooltip: {
      arrow: true,
    },
    MuiTextField: {
      size: "small",
      fontFamily: "Inter-Regular",
      fontSize: 12,
    },
    MuiAutocomplete: {
      size: "small",
      fontFamily: "Inter-Medium",
      fontSize: 11,
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      tb: 768,
      md: 1025,
      lg: 1480, // increased
      xl: 1920,
    },
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
        disableRipple: true,
      },
      styleOverrides: {
        root: {
          textTransform: "none",
          fontFamily: "Inter-Regular",
          borderRadius: 0,
          padding: "4px 25px",
          fontSize: "14px",
        },
        containedPrimary: {
          backgroundColor: "#005fcc",
          color: "#fff",
          "&:hover": {
            backgroundColor: "#004bb5",
          },
        },
        containedSecondary: {
          backgroundColor: "#171718",
          color: "#fff",
          "&:hover": {
            backgroundColor: "#2c2c2c",
          },
        },
        containedWarning: {
          backgroundColor: "#e59900",
          color: "#fff",
          "&:hover": {
            backgroundColor: "#e7ac37",
          },
        },
      },
      variants: [
        {
          props: { variant: "transparent" },
          style: {
            display: "flex",
            alignItems: "center",
            minWidth: "auto",
            color: "#fff",
            backgroundColor: "transparent",
            padding: 0,
            margin: 0,
            "&:hover": {
              backgroundColor: "rgba(255, 255, 255, 0.05)",
            },
          },
        },
        {
          props: { variant: "skyBlue" },
          style: {
            display: "flex",
            alignItems: "center",
            backgroundColor: "#cce0ff",
            padding: "5px",
            justifyContent: "center",
            "&:hover": {
              backgroundColor: "#eff5ff",
            },
          },
        },
        {
          props: { variant: "success" },
          style: {
            display: "flex",
            alignItems: "center",
            backgroundColor: "#2e7d32",
            padding: "4px 25px",
            justifyContent: "center",
            color: "#fafafa",
            "&:hover": {
              backgroundColor: "#29702d",
            },
          },
        },
        {
          props: { variant: "error" },
          style: {
            display: "flex",
            alignItems: "center",
            backgroundColor: "#d32f2f",
            padding: "4px 25px",
            justifyContent: "center",
            color: "#fafafa",
            "&:hover": {
              backgroundColor: "#bd2a2a",
            },
          },
        },
        {
          props: { variant: "filter" },
          style: {
            display: "flex",
            alignItems: "center",
            backgroundColor: "#d32f2f",
            padding: "2px 12px",
            justifyContent: "center",
            color: "#fafafa",
            fontSize: "5px",
            minHeight: "unset",
            "&:hover": {
              backgroundColor: "#bd2a2a",
            },
          },
        },
      ],
    },
    MuiTextField: {
      defaultProps: {
        size: "small",
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "rgba(0, 0, 0, 0.2)",
            borderRadius: 0,
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "rgba(0, 0, 0, 0.4)",
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#008cff",
            borderWidth: 2,
          },
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          "::placeholder": {
            color: "#565656",
            opacity: 1,
          },
        },
      },
    },
  },
};
